module.exports = __webpack_public_path__ + "packs/media/images/Registration_Step_5-f5fd28eb90297fddfd506573d2514a9e.jpg";